import {
  useCustomMutation,
  useInvalidate,
  useNotification,
  useTranslate,
} from '@refinedev/core';
import { Modal } from 'antd';

const { confirm } = Modal;

interface UseTestimonialActionsProps {
  testimonialId?: string | number;
}

interface TestimonialAction {
  mutate: () => void;
  isLoading: boolean;
}

interface TestimonialActions {
  promote: TestimonialAction;
}

export const useTestimonialActions = ({
  testimonialId,
}: UseTestimonialActionsProps): TestimonialActions => {
  const t = useTranslate();
  const invalidate = useInvalidate();
  const { open } = useNotification();

  const {
    mutate: promoteTestimonial,
    mutation: { isPending: isPromoting },
  } = useCustomMutation();

  const handlePromote = () => {
    if (!testimonialId) return;

    confirm({
      title: t('feedback.testimonials.actions.confirm_promote'),
      onOk: () => {
        promoteTestimonial(
          {
            url: `feedback/testimonials/${testimonialId}/promote`,
            method: 'patch',
            values: {},
          },
          {
            onSuccess: () => {
              invalidate({
                resource: 'feedback.testimonials',
                invalidates: ['detail', 'list'],
                id: testimonialId,
              });
              open?.({
                type: 'success',
                message: t('notifications.success'),
                description: t('feedback.testimonials.actions.promote'),
              });
            },
          }
        );
      },
    });
  };

  return {
    promote: {
      mutate: handlePromote,
      isLoading: isPromoting,
    },
  };
};
